import gql from 'graphql-tag';

const GET_REPORT = gql`
  query($reportId: ID!) {
    getReport(reportId: $reportId) {
      reportId
      name
      description
      layout
      createdBy {
        userId
        name
        email
      }
      fullScreenModeEnabled  
      fullScreenModeRefreshInterval
      internalName
      createdTime
      reportType
      reportConfig
      charts {
        chartId
        name
        description
        groupBy #GroupBy
        metrics {
          metricId
          name
          attribute
          metricUnit
          metricFunction # MetricFunction
          filterCondition
          metricOrder
        }
        systemChart
        entity
        createdBy {
          userId
          name
          email
        }
        createdTime
        internalName
        defaultChartType # when the user request to view the chart, it will be rendered in this type first time then the user can switch chart types. It will be available in single GET only.
        # possibleChartTypes
      }
      systemReport
    }
  }
`;

const GET_REPORTS = gql`
  query($listInfo: ListInfoInput) {
    getReports(listInfo: $listInfo) {
      reports {
        reportId
        name
        description
        layout
        createdBy {
          userId
          name
          email
        }
        fullScreenModeEnabled  
        fullScreenModeRefreshInterval
        internalName
        reportConfig
        createdTime
        selectAttributes
        reportType
        systemReport
        entity
        charts {
          chartId
          name
          description
          internalName
          groupBy
          metrics {
            metricId
            name
            attribute
            metricUnit
            metricOrder
            filterCondition
          }
          entity
          defaultChartType
          systemChart
        }
      }
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
      }
    }
  }
`;

const GET_REPORT_SCHEDULE = gql`
  query($input: ReportIdentifierInput!) {
    getReportSchedules(input: $input) {
      schedules {
        id
        scheduleDefinition
        userType
        filterCondition
        notificationTemplate {
          id
          name
          subject
          content
          placeholdersUsed
        }
        shareUsers {
          user {
            userId
            name
          }
          client {
            accountId
            name
          }
        }
      }
    }
  }
`;

const GET_SHARED_REPORT = gql`
  query($sharedReportId: ID) {
    getSharedReport(sharedReportId: $sharedReportId) {
      id
      reportName
      layout
      data
      user {
        userId
        name
        email
        account {
          accountId
        }
      }
      startDateTime
      endDateTime
    }
  }
`;

const GET_REPORT_MODULES = gql`
  query {
    getReportModules
  }
`;

const GET_DOWNLOAD_INVENTORY_LIST = gql`
  query($module: String!, $moduleSpecificId: ID!, $listInfo: ListInfoInput!) {
    getDownloadInventoryList(
      module: $module
      moduleSpecificId: $moduleSpecificId
      listInfo: $listInfo
    ) {
      inventoryList {
        inventoryId
        module
        fileType
        moduleSpecificId
        status
        triggeredTime
        triggeredBy
        completionTime
        triggeredSource
        user {
          userId
          firstName
          lastName
          email
        }
        client {
          name
        }
        sites {
          name
        }
      }
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_EXPORT_REPORT_CONFIG_META = gql`
  query {
    getReportExportConfigMeta
  }
`;

const GET_EXPORT_REPORT_CONFIG = gql`
  query($input: ReportExportConfigInput!) {
    getReportExportConfig(input: $input) {
      reportType
      pdfReportConfig {
        clientLogo
        autoGeneratedText
      }
    }
  }
`;

const GET_REPORT_CONFIGURATION = gql`
  query($reportId: ID!) {
    getReportConfigMeta(reportId: $reportId)
  }
`;

export {
  GET_REPORT,
  GET_REPORTS,
  GET_SHARED_REPORT,
  GET_REPORT_MODULES,
  GET_DOWNLOAD_INVENTORY_LIST,
  GET_EXPORT_REPORT_CONFIG_META,
  GET_EXPORT_REPORT_CONFIG,
  GET_REPORT_CONFIGURATION,
  GET_REPORT_SCHEDULE
};
